import { SET_ROLE_PERMISSIONS } from '../../actionTypes/rolePermission'

const initialState = {
	permissions: null,
}

export function rolePermissionReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ROLE_PERMISSIONS:
      return {
        ...state,
				permissions: action.value,
      }
    default:
      return state
  }
}
